var map = {
	"./back-undoredo.svg": [
		"f884",
		"chunk-2d22d804"
	],
	"./brightness-contrast-image.svg": [
		"a2db",
		"chunk-2d208125"
	],
	"./circulo-anotacao.svg": [
		"5dab",
		"chunk-2d0d3c26"
	],
	"./crosshair-image.svg": [
		"71bc",
		"chunk-2d0d6591"
	],
	"./curva-anotacao.svg": [
		"43f3",
		"chunk-2d0c1042"
	],
	"./delete-anotacao.svg": [
		"8834",
		"chunk-2d0dee57"
	],
	"./fit-to-screen-image.svg": [
		"8da1",
		"chunk-2d0e9912"
	],
	"./fix-segmentacao-dente.svg": [
		"b090"
	],
	"./forward-undoredo.svg": [
		"d5ae",
		"chunk-2d21e92b"
	],
	"./fullscreen-other.svg": [
		"818e",
		"chunk-2d0dd4dc"
	],
	"./move-cursor-image.svg": [
		"2809",
		"chunk-2d0b33c5"
	],
	"./path-anotacao.svg": [
		"0f28",
		"chunk-2d0af7f2"
	],
	"./ponto-anotacao.svg": [
		"ad31",
		"chunk-2d2136b7"
	],
	"./reset-job.svg": [
		"7caa",
		"chunk-2d0e2122"
	],
	"./reta-anotacao.svg": [
		"8bc7",
		"chunk-2d0e91d4"
	],
	"./retangulo-anotacao.svg": [
		"116c",
		"chunk-2d0aa603"
	],
	"./retangulo-inc-anotacao.svg": [
		"085e",
		"chunk-2d0a4bce"
	],
	"./save-image.svg": [
		"030f"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "6b2d";
module.exports = webpackAsyncContext;